import $ from 'jquery';
import {loadStripe} from '@stripe/stripe-js';

const stripePayment = {

    stripePaymentFormWrapper: $('#js-stripe-payment-form-wrapper'),
    stripePaymentConfirmationWrapper: $('#js-stripe-payment-confirmation-wrapper'),
    paymentModeForm: $('#paymentModeForm'),
    // paymentFormSubmit: $('#paymentModeForm#submit'),
    paymentFormSubmit: $('#js-common-submit'),
    // stripePaymentForm: $('#paymentModeForm'),
    stripePaymentFormSubmit: $('#js-stripe-submit'),
    stripeErrorField: $('#js-error-message'),
    stripe: undefined,

    /**
     * Inits the js on the payment page and shows the CC form.
     */
    initPaymentPage(apiKey, amount, currency, lang, billingDetails) {
        loadStripe(apiKey).then((stripe) => {
            this.stripe = stripe;
            const options = {
                mode: 'payment',
                amount: amount,
                currency: currency,
                paymentMethodCreation: 'manual',
                captureMethod: 'manual',
                locale: lang
            };
            const elements = stripe.elements(options);
            const paymentElementOptions = {layout: 'accordion'};
            const paymentElement = elements.create('payment', paymentElementOptions);
            paymentElement.mount('#js-payment-element');

            this.stripePaymentFormSubmit.on('click', async (event) => {
                event.preventDefault();
                if (this.stripePaymentFormSubmit.disabled) {
                    return;
                }
                this.stripePaymentFormSubmit.disabled = true;

                const {error: submitError} = await elements.submit();
                if (submitError) {
                    this.handleError(submitError);
                    return;
                }
                const {error, confirmationToken} = await this.stripe.createConfirmationToken({
                    elements,
                    params: {
                        payment_method_data: {
                            billing_details: billingDetails
                        }
                    }
                });
                if (error) {
                    this.handleError(error);
                    return;
                }

                $('#stripeConfirmationToken').val(JSON.stringify(confirmationToken));
                this.paymentModeForm.submit();
            });
        });
    },

    /**
     * Inits the js on the stripePaymentRedirectPage.jsp for the payment confirmation.
     */
    initConfirmPaymentPage(apiKey, lang, returnUrlError, returnUrl, clientSecret, confirmationTokenId) {
        loadStripe(apiKey, {locale: lang}).then((stripe) => {
            this.stripe = stripe;
            stripePayment.confirmPaymentIntent(returnUrlError, returnUrl, clientSecret, confirmationTokenId)
        })
    },

    confirmPaymentIntent(returnUrlError, returnUrl, clientSecret, confirmationTokenId) {
        this.stripe.confirmPayment({
            clientSecret: clientSecret,
            confirmParams: {
                confirmation_token: confirmationTokenId,
                return_url: returnUrl
            }
        }).then(function (result) {
            if (result.error) {
                const errorMsg = encodeURIComponent(result.error.message);
                window.location = returnUrlError + '?errorMsg=' + errorMsg;
            }
        }).catch(function (error) {
            if (result.error) {
                window.location = returnUrlError + '?error=true';
            }
        });
    },

    showStripePaymentForm() {
        if (this.stripePaymentFormWrapper.hasClass('d-none')) {
            this.stripePaymentFormWrapper.removeClass('d-none');
        }

        if (this.stripePaymentFormSubmit.hasClass('d-none')) {
            this.stripePaymentFormSubmit.removeClass('d-none');
        }
        if (!this.paymentFormSubmit.hasClass('d-none')) {
            this.paymentFormSubmit.addClass('d-none');
        }
    }
    ,

    hideStripePaymentForm() {
        if (!this.stripePaymentFormWrapper.hasClass('d-none')) {
            this.stripePaymentFormWrapper.addClass('d-none');
        }

        if (!this.stripePaymentFormSubmit.hasClass('d-none')) {
            this.stripePaymentFormSubmit.addClass('d-none');
        }

        if (this.paymentFormSubmit.hasClass('d-none')) {
            this.paymentFormSubmit.removeClass('d-none');
        }
    },

    handleError(error) {
        stripePayment.stripeErrorField.text(error.message).addClass('d-block');
        this.stripePaymentFormSubmit.disabled = false;
    },

    bindEvents() {
        $('.payment-mode__wrapper').on('click', function () {
            const isStripe = $(this).find('[data-mode="stripe"]').length > 0;
            if (isStripe) {
                stripePayment.showStripePaymentForm();
            } else {
                stripePayment.hideStripePaymentForm();
            }
        });
    }
};


$(() => {
    if (stripePayment.stripePaymentFormWrapper.length) {
        stripePayment.bindEvents();
        let apiKey = stripePayment.stripePaymentFormWrapper.data('key');
        let cartTotal = stripePayment.stripePaymentFormWrapper.data('total');
        let currency = stripePayment.stripePaymentFormWrapper.data('currency');
        let lang = stripePayment.stripePaymentFormWrapper.data('lang');
        let billingDetails = {
            name: stripePayment.stripePaymentFormWrapper.data('addressname'),
            email: stripePayment.stripePaymentFormWrapper.data('addressemail'),
            address: {
                line1: stripePayment.stripePaymentFormWrapper.data('addressline1'),
                line2: stripePayment.stripePaymentFormWrapper.data('addressline2'),
                city: stripePayment.stripePaymentFormWrapper.data('addresscity'),
                postal_code: stripePayment.stripePaymentFormWrapper.data('addresszip'),
                country: stripePayment.stripePaymentFormWrapper.data('addresscountry')
            }
        };
        if (apiKey !== '' && cartTotal !== '' && currency !== '' && lang !== '') {
            stripePayment.initPaymentPage(apiKey, cartTotal, currency, lang, billingDetails);
        } else {
            window.location = '/';
        }
    }

    if (stripePayment.stripePaymentConfirmationWrapper.length) {
        let apiKey = stripePayment.stripePaymentConfirmationWrapper.data('key');
        let lang = stripePayment.stripePaymentConfirmationWrapper.data('lang');
        let clientSecret = stripePayment.stripePaymentConfirmationWrapper.data('cs');
        let confirmationTokenId = stripePayment.stripePaymentConfirmationWrapper.data('ct');
        let returnUrl = stripePayment.stripePaymentConfirmationWrapper.data('returnurl');
        let returnUrlError = stripePayment.stripePaymentConfirmationWrapper.data('returnurlerror');
        if (apiKey !== '' && returnUrl !== '' && clientSecret !== '' && confirmationTokenId !== '') {
            stripePayment.initConfirmPaymentPage(apiKey, lang, returnUrlError, returnUrl, clientSecret, confirmationTokenId);
        } else {
            window.location = '/';
        }
    }
});

export default stripePayment;